module.exports = __webpack_public_path__ + "static/xeneco-logo-51b8fc595d34acf8096c462bff593a98.png";